<script>
// 设置工程师modal
import EngineerSelect from "@/views/auditing-order/components/widgets/engineer-select";
// import i18n from "@/i18n";

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    companyId: {
      type: Number,
      default: 0
    },
    provinceId: {
      type: Number,
      default: 0
    },
    customerId: {
      type: Number,
      default: 0
    },
    engineerType:{
      type:String,
      default:''
    },
    defaultSelectId:{ // 选中下拉的默认值
      type:String,
      default: ''
    },
  },
  data () {
    return {
      showModal: false,
      engineerId: null,
      title:{
        '1':this.$t("page.auditing.sales_service_engineer"),
        '2':this.$t("page.auditing.technical_service_engineer"),
        '3':this.$t("page.auditing.agent_service"),
        '4':this.$t("page.auditing.authorized_service_engineer"),
      }
    }
  },
  methods: {
    change(value) {
      this.engineerId = value
    },
    ok () {
      this.$emit('ok', this.engineerId)
    },
    cancel () {
      this.$emit('cancel')
    },
    getEngineer(val){
      this.$refs.childEngineer.getEngineer(val);
    }
  },
  components: {
    EngineerSelect,
  },
  computed: {
    okDisabled() {
      return !this.engineerId
    }
  },
  watch: {
    show: {
      immediate: true,
      handler(val) {
        this.showModal = val
      }
    },
    showModal(val) {
      if (!val) {
        this.$emit('cancel')
      }
    },
  }
}

</script>
<template>

  <b-modal v-model="showModal" id="setCompanyModal" hide-footer :title="title[engineerType]" header-class="p-3 bg-light"
           class="v-modal-custom" centered>

    <engineer-select ref="childEngineer" :value="defaultSelectId" :engineerType="engineerType" :company-id="companyId" :province-id="provinceId" :customerId="customerId" @changed="change"></engineer-select>

    <div class="hstack gap-2 justify-content-end mt-5">
      <b-button type="button" variant="light" @click="cancel">
        {{ $t('base.cancel') }}
      </b-button>
      <b-button type="button" variant="success" @click="ok" :disabled="okDisabled">
        {{ $t('base.done') }}
      </b-button>
    </div>

  </b-modal>


</template>
